import { FC } from 'react';

import { Box } from '@mui/material';
import { BUSINESS_TOOL_MODE } from 'constants/businessTool';
import { useBusinessToolSessionStore, useBusinessToolStore } from 'store/useBusinessToolStore';
import { getSetBusinessPlanType, getSetBusinessToolMode } from 'store/useBusinessToolStore/selectors';

import { IWorkspaceBusinessPlansProps } from 'pages/Workspace/types';

import { IBusinessPlanType } from 'interfaces/businessPlan';

import { CreateProjectMobile } from '../CreateProjectMobile/CreateProjectMobile';
import { WorkspaceBusinessPlanItem } from '../WorkspaceBusinessPlans/WorkspaceBusinessPlanItem/WorkspaceBusinessPlanItem';

import styles from './WorkspaceBusinessPlansMobile.module.scss';

export const WorkspaceBusinessPlansMobile: FC<IWorkspaceBusinessPlansProps> = ({ businessPlan }) => {
  const setBusinessToolMode = useBusinessToolSessionStore(getSetBusinessToolMode);
  const setBusinessPlanType = useBusinessToolStore(getSetBusinessPlanType);

  const handleNavigate = (type: IBusinessPlanType) => {
    setBusinessToolMode(BUSINESS_TOOL_MODE.EDIT);
    setBusinessPlanType(type);
  };

  return (
    <>
      <Box className={styles.wrapper}>
        {businessPlan.content.map((item) => (
          <WorkspaceBusinessPlanItem key={item.uuid} eachBusinessPlan={item} handleNavigate={handleNavigate} />
        ))}
      </Box>
      <CreateProjectMobile isButtonFixed />
    </>
  );
};
